import styled from "styled-components";
import { zIndex } from "@sonder/ui/source/styled/theme";

interface CabinetProps {
  left?: string;
}

export const Cabinet = styled.div<CabinetProps>`
  bottom: 0;
  left: ${props => props.left || 0};
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  right: 0;
  top: 0;
  z-index: ${zIndex.cabinet};
`;
